import { Box, Text } from '@chakra-ui/react';

export const TooltipPreview = () => {
  return (
    <Box>
      <Text>TooltipPreview - Coming soon</Text>
    </Box>
  );
};
